import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { SelectedListToFilter } from '../../../../interfaces/reports/reports';

@Component({
  selector: 'app-filter-selector-table',
  templateUrl: './filter-selector-table.component.html',
  styleUrls: ['./filter-selector-table.component.css'],
})
export class FilterSelectorTableComponent implements OnInit {

  @Input() assetList: SelectedListToFilter[] = [];
  @Input() zonesList: SelectedListToFilter[] = [];
  @Input() stateLicenseList: SelectedListToFilter[] = [];

  // validaciones  calendarios
  controlForm: FormGroup = new FormGroup({});

  get dateFromReport(): FormControl {
    return this.controlForm.controls.fromDayReport as FormControl;
  }
  get dateUntilReport(): FormControl {
    return this.controlForm.controls.untilDayReport as FormControl;
  }

  // validaciones  calendarios
  get controlDateStartError(): string {
    const error = this.controlForm.controls.fromDayReport.errors;
    if (error) return error.description;
    return '';
  }
  get controlDateEndError(): string {
    const error = this.controlForm.errors;
    if (error) return error.description;
    return '';
  }
  constructor() { }

  ngOnInit(): void {
  }

}
